<template>
    <div>
        <app-sub-title text="Formatos" />
        <button class="btn btn-primary" @click="create">
            <i class="fa fa-plus"></i> Crear Formato
        </button>
        <app-format-list
            v-if="!!data"
            :data="data"
            :on-delete="startDeleteFormat"
        />
        <app-pop-up title="Confirmación" id="format-remove">
            <div slot="body">
                <h2>¿Esta seguro que desea eliminar este formato?</h2>
            </div>
            <div class="buttons" slot="buttons">
                <button
                    class="btn btn-confirm"
                    @click="deleteFormat(itemSelect)"
                >
                    <i class="fa fa-trash-o" aria-hidden="true"></i> Confirmar
                    Eliminación
                </button>
            </div>
        </app-pop-up>
    </div>
</template>
<script>
import FormatAdminForm from './FormatAdmin/FormatAdminForm.vue'
import Title from '../../UI/Layout/Title.vue'
import PageContent from '../../UI/Layout/PageContent.vue'
import FormatList from './FormatList.vue'
export default {
    components: {
        // appFormatAdminForm: FormatAdminForm,
        appPageContent: PageContent,
        appTitle: Title,
        appFormatList: FormatList,
    },
    data() {
        return {
            data: [],
            fields: [],
        }
    },
    methods: {
        async loadFormats() {
            try {
                const { data } = await repo.get('formats')
                this.data = data
                console.log(data)
            } catch (err) {
                this.handleErrors(err)
            }
        },
        create() {
            return this.$router.push({ name: 'formatCreate' })
        },
        startDeleteFormat(item) {
            this.itemSelect = item
            this.$bus.$emit('format-remove.open')
        },
        async deleteFormat(item) {
            const { data } = await repo.delete(`formats/${item.id}`)
            if (data.status) {
                this.$bus.$emit('format-remove.close')
                this.loadFormats()
                toastr.success('Formato eliminado')
            } else {
                toastr.error(data.msg)
                this.$emit('error', data)
            }
        },
    },

    created() {
        this.loadFormats()
    },
}
</script>
